import { action, mutatorAction } from 'satcheljs';
import { getSearchStore } from 'mini-3s-search-store';
import { Suggestion } from 'mini-3s-search-store/lib/store/schema/Suggestion';

/**Action used to start a search session */
const startSuggestionSession = action('startSuggestionSession');

/**Action used to fetch suggestions */
const fetchSuggestions = action('fetchSuggestions', (queryString: string) => ({ queryString }));

/**Action used to set the selected suggestion in store */
const setSelectedSuggestion = action('setSelectedSuggestion', (suggestion: Suggestion) => ({
    suggestion,
}));

/**Action used to submit search */
const submitSearch = action(
    'submitSearch',
    (
        queryString: string,
        updateRoute: (newPath: string) => void,
        selectedSuggestion?: Suggestion
    ) => ({ queryString, updateRoute, selectedSuggestion })
);

/**Mutator function which sets the current queryString */
const setCurrentQuery = mutatorAction('setCurrentQuery', (queryString: string) => {
    getSearchStore().currentQuery = queryString;
});

/** Mutator function that clears the ZeroQuery suggestions */
const clearZeroQuerySuggestions = mutatorAction('clearZeroQuerySuggestions', () => {
    getSearchStore().zeroQuerySuggestions = null;
});

export {
    startSuggestionSession,
    fetchSuggestions,
    setSelectedSuggestion,
    setCurrentQuery,
    submitSearch,
    clearZeroQuerySuggestions,
};
